import axios from "axios";
import debounce from "lodash.debounce";

export default {
  name: 'SelectMeterSerialNo',
  props: {
    selectedItemId: {
      type: Number,
      default: -1,
    },
    suggestedMeter: {
      type: Object,
      default: null
    }
  },
  components: {
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    CircleLoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
  },
  data: function () {
    return {
      items: [],
      trimmedItems: [],
      loading: false,

      paginationOptions: {
        "PageSize": 10,
        "Page": 1
      },
      search: '',
      debouncedFunc: null,
      selectedItem: {},
    }
  },
  created() {
    this.debouncedFunc = debounce(() => {
      this.getMeters(this.search);
    }, 2500);

    this.init();
  },
  watch: {
    "search": function (val) {
      if (val != '' && val != null)
        this.debouncedFunc();
    },
  },
  beforeUnmount() {
    this.debounceFunc.cancel();
  },
  methods: {
    init() {
      this.getMeters();
    },
    getClass(item) {
      if (!item || !item.id || item.id <= 0 || !this.selectedItem)
        return;

      if (this.selectedItem.id == item.id)
        return 'background-color-gray_wached';
    },
    onSelect(item) {
      if (!item || !item.id || item.id <= 0) {
        this.selectedItem = null;
        return;
      }

      this.selectedItem = item;

      this.$emit('selected', item);
    },
    addSuggestedMeter() {
      this.$emit('selected', {
        meterId: this.suggestedMeter.suggestedMeterId,
        ref: this.suggestedMeter.suggestedMeterSerialNo,
        selected: true
        });
    },
    async getMeters(searchQuery = null) {
      this.items.length = 0;

      let param = {
        AllMeters: true,
        Options: this.paginationOptions,
        ExistingSerialNo: false,
      }

      if (searchQuery && searchQuery.length > 0) {
        param.ExistingSerialNo = true;
        param['SerialNo'] = searchQuery;
      }

      this.loading = true;
      axios.post('/DmConnection/GetExistingMeterItems', param)
        .then(response => {
          if (response.status == 200) {
            if (response.data.items.length > 0) {
              for (let i = 0; i < response.data.items.length; i++)
                response.data.items[i]['id'] = i + 1;
            }

            this.items = response.data.items;
          }
          else
            this.$oldAlertMsg(this.$t("disconnections.RecordsError"));
        })
        .catch(e => {
          this.$oldAlertMsg(this.$t("disconnections.RecordsError"));
        })
        .finally(() => this.loading = false);
    },   

    searchMetersButtonAction() {
      this.debouncedFunc.cancel();
      this.getMeters(this.search)
    },
    searchCleared() {
      this.getMeters();
      this.search = '';
    },
  }
}
